import { defaultTheme } from "../styles/themes/themeSelection";
import { useTheme } from "../styles/themes/themeContext";

export const LeaftechLogo = ({ imgProps, ...props }) => {
  return (
    <Logo
      href={defaultTheme.links.website}
      imgProps={imgProps}
      imgSrc={defaultTheme.logo.mainSrc}
      {...props}
    />
  );
};

export const ClientLogo = ({ imgProps, ...props }) => {
  const theme = useTheme();
  return (
    <Logo
      href={theme.links.website}
      imgProps={imgProps}
      imgSrc={theme.logo.mainSrc}
      {...props}
    />
  );
};

export const Logo = ({ href, imgProps, imgSrc, ...props }) => {
  return (
    <a href={href} rel="noreferrer" target="_blank" {...props}>
      <img alt="logo" src={imgSrc} {...imgProps} />
    </a>
  );
};
